(() => {
  const normalize = (text) => text.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  const enhance = () => {
    document.querySelectorAll('[data-seedora-article-body]').forEach((body) => {
      // Only suppress a matching introductory heading; preserve different headings.
      const firstHeading = body.querySelector('h1, h2');
      if (firstHeading && normalize(firstHeading.textContent) === normalize(body.dataset.articleTitle)) {
        firstHeading.hidden = true;
      }
      // Article HTML sometimes brings its own H1; retain its text as a subsection.
      body.querySelectorAll('h1:not([hidden])').forEach((heading) => {
        const replacement = document.createElement('h2');
        for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
        replacement.append(...heading.childNodes);
        heading.replaceWith(replacement);
      });
    });
  };
  enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
